import {cloneDeep as _cloneDeep} from 'lodash';
import ModuleModel from "@/models/ModuleModel"

const ModulesModule = {
    namespaced: true,
    state: () => ({
        // Список модулів для таблиці
        modules: [],
        // Поточний модуль для форм
        module: _cloneDeep(ModuleModel),
        // Загальна кількість модулів для пагінації
        modulesCount: 0,
        // Всі модулі для вибору (без пагінації)
        allModules: [],
        // Параметри фільтрації
        filters: {
            search: null,
            course_id: null,
            sort_by: 'order',
            sort_dir: 'asc',
            per_page: 30,
            page: 1
        }
    }),
    
    getters: {
        getModules(state) {
            return state.modules
        },
        getModule(state) {
            return state.module
        },
        getModulesCount(state) {
            return state.modulesCount
        },
        getAllModules(state) {
            return state.allModules
        },
        getFilters(state) {
            return state.filters
        }
    },
    
    mutations: {
        setModules(state, payload) {
            state.modules = payload
        },
        setModule(state, payload) {
            state.module = payload
        },
        setModulesCount(state, payload) {
            state.modulesCount = payload
        },
        setAllModules(state, payload) {
            state.allModules = payload
        },
        setFilters(state, payload) {
            state.filters = { ...state.filters, ...payload }
        },
        resetFilters(state) {
            state.filters = {
                ...state.filters,
                search: null,
                course_id: null,
                sort_by: 'order',
                sort_dir: 'asc',
                page: 1
            }
        }
    },
    
    actions: {
        setModules(context, payload) {
            context.commit('setModules', payload);
        },
        setModule(context, payload) {
            context.commit('setModule', payload);
        },
        setModulesCount(context, payload) {
            context.commit('setModulesCount', payload);
        },
        setAllModules(context, payload) {
            context.commit('setAllModules', payload);
        },
        setFilters(context, payload) {
            context.commit('setFilters', payload);
        },
        resetFilters(context) {
            context.commit('resetFilters');
        }
    }
}

export default ModulesModule;

